import { StyleSheet } from 'react-native';
import { heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  cardsContainerLarge: {
    flex: 0.9,
    marginBottom: hp('2%'),
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  cardColumnLarge: {
    flex: 1,
  },
  titleColumnSmall: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    minHeight: 45,
  },
  cardColumnSmall: {
    flexDirection: 'column',
    marginBottom: 15,
  },
  cardHeaderLarge: {
    paddingTop: 5,
    paddingBottom: 5,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f3f3f323',
  },
  cardHeaderSmall: {
    flex: 0.3,
    paddingTop: 5,
    paddingBottom: 5,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f3f3f323',
  },
  cardHeaderSelectedSmall: {
    flex: 0.3,
    paddingTop: 5,
    paddingBottom: 5,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
  textLarge: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '700',
  },
  textSmall: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '700',
  },
  selectedText: {
    color: '#0F6657',
    fontSize: 12,
    fontWeight: '700',
  },
});